import React, { useState, lazy, Suspense } from 'react';
import './social-contract-sample-modal.styles.scss'

const Modal = lazy(() => import('components/commons/modal'));

const SocialContractSampleModal: React.FC = (): JSX.Element => {
    const [visible, setVisible] = useState(false);

    return (
        <Suspense fallback="">
            <a
                href={void(0)}
                className="medium"
                onClick={() => setVisible(true)}
            >
                precisa de ajuda com este documento?
            </a>

            <Modal
                title=""
                visible={visible}
                onClose={() => setVisible(false)}
            >
                <div className="c-modal__social">
                    <div className="title mb-4">
                        informações que buscamos no seu contrato social
                    </div>
                    <div>
                        <label className="c-modal__social__subtitles">nome da empresa</label>
                        <p className="mb-2">
                            <label className="c-modal__social__subtitles">capital social:</label>
                            valor que os sócios/acionistas estabelecem para sua empresa no momento da abertura;
                        </p>
                        <p className="mb-2">
                            <label className="c-modal__social__subtitles">qualificação dos sócios:</label>
                            identificação e cadastro do nome completo de cada um, estado civil, profissão, RG e CPF, data de nascimento, nacionalidade e endereço;
                        </p>
                        <p className="mb-2">
                            <label className="c-modal__social__subtitles">tipo de sociedade:</label>
                            LTDA, Eireli, MEI, etc ...
                        </p>
                        <p className="mb-2">
                            <label className="c-modal__social__subtitles">atividades da empresa:</label>
                            ramo de atuação;
                        </p>
                        <p className="mb-2">
                            <label className="c-modal__social__subtitles">sede/local de atuação da empresa:</label>
                            endereço da matriz e das filiais (caso existam)
                        </p>
                    </div>
                </div>
            </Modal>
        </Suspense>
    );
};

export default SocialContractSampleModal;
